import { render, staticRenderFns } from "./BrandCase.vue?vue&type=template&id=3be59558&scoped=true&"
import script from "./BrandCase.vue?vue&type=script&lang=js&"
export * from "./BrandCase.vue?vue&type=script&lang=js&"
import style0 from "./BrandCase.vue?vue&type=style&index=0&id=3be59558&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be59558",
  null
  
)

export default component.exports